import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import './InternalError.scss';

/** @extends React.Component */
class InternalError extends BcReactComponent {
  renderAppVersion() {
    const { appVersion } = this.props;

    if (!appVersion) {
      return '';
    }

    return (
      <span data-test-id="app-version">
        NERF: {appVersion}
        <br />
      </span>
    );
  }

  renderErrorId() {
    const { errorId } = this.props;

    if (!errorId) {
      return null;
    }

    return (
      <span data-test-id="error-id">
        Error ID: {errorId}
        <br />
      </span>
    );
  }

  render() {
    const timestamp = moment().format('YYYY/MM/DD HH:mm');

    return (
      <div className="cp-internal-error">
        <div className="main-error-content">
          <h1 className="title">We&rsquo;re very sorry!</h1>
          <p className="description">
            Something on our end isn&rsquo;t working properly. <br />
            We&rsquo;re working hard to fix the problem.
          </p>
          <hr />
          <h2>In the meantime, you can&hellip;</h2>
          <p className="description">
            <a href="/dashboard">
              <FormattedMessage id="browse_library_catalogue" />
              &nbsp;&raquo;
            </a>
          </p>
        </div>
        <hr />
        <div className="error-ids">
          {this.renderErrorId()}
          {this.renderAppVersion()}
          {timestamp}
        </div>
        <div className="report-problem">
          <h2>To report this problem&hellip;</h2>
          <p>Take a screenshot of this window and share it with your library.</p>
        </div>
      </div>
    );
  }
}

InternalError.displayName = 'InternalError';

InternalError.propTypes = {
  appVersion: PropTypes.string,
  errorId: PropTypes.string
};

export default InternalError;
